import { get, filter, flow, map, pickBy, sortBy, values } from 'lodash/fp';

const mapCategories = map(({ id, abbreviation, name, shortName }) => ({
  id,
  abbr: abbreviation,
  name,
  shortName: shortName || name
}));

const mapAndFilterCategories = categories => {
  const filteredCategories = flow(
    pickBy((v, k) => k !== 'race_date'),
    values,
    filter('display')
  )(categories);

  if (filteredCategories.length === 0) {
    return mapCategories(categories);
  }

  return mapCategories(sortBy('order', filteredCategories));
};

const normaliseGames = data => {
  const dateKey = get('form_types.race_date.id', data);
  const formData = get('player.form', data) || [];

  return formData.map((item, i) => {
    return {
      id: i,
      startTime: get(dateKey, item),
      stats: pickBy((v, k) => k !== dateKey, item)
    };
  });
};

const decodeRacingCompetitionStats = data => ({
  categories: flow(get('form_types'), mapAndFilterCategories)(data),
  games: normaliseGames(data),
  name: get('player.player.name', data),
  player: get('player.player', data),
  rider: get('player.rider', data),
  trainer: get('player.trainer', data),
  stats: get('player.stats', data)
});

export default decodeRacingCompetitionStats;
